<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
========================================================================================== -->
<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="props.classes">
        <p class="text-sm">
          <span>&copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <span><a class="text-dark" href="https://www.cfc-solutions.fr" target="_blank" rel="nofollow">CFC Solutions</a></span>
        </p>
        <span class="md:flex hidden items-center text-sm">
            <span>Réalisé avec</span>
            <i class="far fa-heart text-danger mx-1"></i>
            <span v-if="props.clientName">&nbsp;pour <strong>{{ props.clientName }}</strong></span>
        </span>
    </footer>
</template>
<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    },
    clientName: {
      type: String,
      default: ''
    }
  }
}
</script>
